// Mapping of label_image enums to their respective SVG icon renderers.
// Each entry is a function returning the SVG, parameterized by the fill color.
export const LABEL_IMAGE_ICONS = {
  hotel: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M7 1a2 2 0 0 0-2 2v19h14V3a2 2 0 0 0-2-2H7Zm10 2H7v17h10V3ZM9 5h2v3H9V5Zm2 5H9v3h2v-3Zm-2 5h2v3H9v-3Zm6-10h-2v3h2V5Zm-2 5h2v3h-2v-3Zm2 5h-2v3h2v-3Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  aparthotel: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M7.408 4 5 6.751V20h6V4H7.408ZM3 22h18V9.376a1 1 0 0 0-.247-.659l-2.954-3.376A1 1 0 0 0 17.046 5H13V3a1 1 0 0 0-1-1H6.954a1 1 0 0 0-.753.341L3.247 5.717A1 1 0 0 0 3 6.376V22Zm16-2h-6V7h3.593L19 9.751V20ZM9 7H7v2h2V7Zm-2 4h2v2H7v-2Zm2 4H7v2h2v-2Zm6-4h2v2h-2v-2Zm2 4h-2v2h2v-2Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  appartement: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='-2 -1 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6h4a2 2 0 0 1 2 2v11H0V2Zm12 17V2H2v17h10Zm2 0h4v-9h-4v9ZM4 4h2v3H4V4Zm2 5H4v3h2V9Zm-2 5h2v3H4v-3Zm6-10H8v3h2V4ZM8 9h2v3H8V9Zm2 5H8v3h2v-3Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  villa: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M6 12V5.67l7-1.274V8H8v4H6Zm2 2H4v6h4v-6Zm0 8H2v-9a1 1 0 0 1 1-1h1V4l9.821-1.786A1 1 0 0 1 15 3.198V8h6a1 1 0 0 1 1 1v13H8Zm2-2V10h10v10h-6v-4h-2v4h-2Zm2-6v-2h2v2h-2Zm6-2h-2v2h2v-2Zm-2 4h2v2h-2v-2Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  bungalow: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='-2 -1 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6h4a2 2 0 0 1 2 2v11H0V2Zm12 17V2H2v17h10Zm2 0h4v-9h-4v9ZM4 4h2v3H4V4Zm2 5H4v3h2V9Zm-2 5h2v3H4v-3Zm6-10H8v3h2V4ZM8 9h2v3H8V9Zm2 5H8v3h2v-3Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  vakantieparken: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M4 8.665V14h2v-3h2v5H3a1 1 0 0 1-1-1V8.241a1 1 0 0 1 .304-.717l5-4.849a1 1 0 0 1 1.392 0l4.961 4.81L12 9.094v-.428l-4-3.88-4 3.88ZM12 20v-5.335l4-3.88 4 3.88V20h-4v-3h-2v3h-2Zm3.304-11.325a1 1 0 0 1 1.392 0l5 4.848a1 1 0 0 1 .304.718V21a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-6.759a1 1 0 0 1 .304-.717l5-4.849Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  camping: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M12 2 2.724 20.553A1 1 0 0 0 3.618 22h16.764a1 1 0 0 0 .894-1.447L12 2ZM5.236 20 11 8.472V20H5.236Zm13.528 0H13V8.472L18.764 20ZM11 14l-3 6h3v-6Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  kasteel: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M6 2H4v6l1 2v8l-1 2v2h16v-2l-1-2v-8l1-2V2h-2v2h-5V2h-2v2H6V2Zm0 4v1.528L6.236 8h11.528L18 7.528V6H6Zm11 4H7v8.472l-.211.422L6.236 20h11.528l-.553-1.106-.211-.422V10Zm-8 5a3 3 0 1 1 6 0v3H9v-3Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  landhuis: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M9 7.828V20h2v-4h2v4h2V7.828l-3-3-3 3ZM17 16v4h3v-4h-3Zm3-2h-3v-2h1.172L20 13.828V14Zm2 0v8H2v-9l3-3h2V7l3.586-3.586L12 2l1.414 1.414L17 7v3h2l3 3v1ZM5.828 12H7v2H4v-.172L5.828 12ZM7 16H4v4h3v-4Zm6-6V8h-2v2h2Zm0 2h-2v2h2v-2Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
  pension: color => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='-2 -1 24 24'
      style={{
        minWidth: '18px',
        minHeight: '18px',
        width: '18px',
        height: '18px',
      }}
    >
      <path
        fill={color}
        fill-rule='evenodd'
        d='M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6h4a2 2 0 0 1 2 2v11H0V2Zm12 17V2H2v17h10Zm2 0h4v-9h-4v9ZM4 4h2v3H4V4Zm2 5H4v3h2V9Zm-2 5h2v3H4v-3Zm6-10H8v3h2V4ZM8 9h2v3H8V9Zm2 5H8v3h2v-3Z'
        clip-rule='evenodd'
      ></path>
    </svg>
  ),
}
